module.exports = __webpack_public_path__ + "static/logo_black-a4c020a71b37e014cfda53752d0f38d0.jpg";